import React, { memo } from 'react';
import LeagueFlag from './prediction-feed/LeagueFlag';
import { getLandingLeagueId } from '../data/landingsConfig';

const LandingMark = memo(({ landing, size = 16, className = '' }) => {
  const leagueId = getLandingLeagueId(landing);
  if (leagueId) {
    return <LeagueFlag leagueId={leagueId} size={size} className={className} />;
  }

  const Icon = landing.icon;
  if (typeof Icon !== 'function') return null;

  return (
    <Icon
      className={`flex-shrink-0 text-current ${className}`}
      style={{ width: size, height: size }}
      aria-hidden="true"
    />
  );
});

LandingMark.displayName = 'LandingMark';

export default LandingMark;
